"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.YandexPlus = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var YandexPlus = function YandexPlus(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 246,
    height: 48,
    viewBox: "0 0 246 48",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#YandexPlus_svg__YandexPlus_svg__clip0_20777_110404)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "YandexPlus_svg__a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 246,
    height: 36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246 6H0v36h246V6z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#YandexPlus_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "YandexPlus_svg__b",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 6,
    width: 128,
    height: 36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246 6H118.444v36H246V6z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#YandexPlus_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.667 42c10.063 0 18.222-8.059 18.222-18S146.73 6 136.667 6c-10.064 0-18.223 8.059-18.223 18s8.159 18 18.223 18z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.889 24c0 9.941-8.159 18-18.222 18-10.064 0-18.223-8.059-18.223-18s8.159-18 18.223-18c1.966 0 3.859.308 5.634.877L138.147 19.5h-12.128l-1.482 4.5h12.13l-3.553 10.8h5.011l3.553-10.8h13.211zm-.574-4.5h-11.156l3.477-10.57c3.745 2.423 6.533 6.171 7.679 10.57z",
    fill: "url(#YandexPlus_svg__YandexPlus_svg__paint0_linear_20777_110404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.083 10.395H164V37.5h4.777V14.061h8.528V37.5h4.778V10.395z",
    fill: "url(#YandexPlus_svg__YandexPlus_svg__paint1_linear_20777_110404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.191 33.483l.276.195c.184.104.448.156.79.156.763 0 1.263-.39 1.5-1.17.237-.78.395-2.21.474-4.29l.395-10.49h13.463V37.5h-4.699V21.55h-4.777l-.276 7.02c-.079 2.157-.277 3.925-.592 5.303-.316 1.378-.843 2.392-1.58 3.042-.736.65-1.776.975-3.119.975-.552 0-1-.065-1.342-.195l-.513-.195v-4.017z",
    fill: "url(#YandexPlus_svg__YandexPlus_svg__paint2_linear_20777_110404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.144 37.89c-3.132 0-5.475-.871-7.028-2.613-1.526-1.768-2.29-4.29-2.29-7.566 0-2.002.342-3.77 1.027-5.304.684-1.534 1.697-2.73 3.04-3.588 1.369-.884 3.053-1.326 5.053-1.326 1.159 0 2.159.09 3.001.273.869.156 1.553.377 2.053.663v3.939c-.474-.286-1.119-.56-1.935-.82a8.525 8.525 0 00-2.605-.39c-1.527 0-2.711.547-3.554 1.639-.815 1.066-1.224 2.665-1.224 4.797 0 2.028.369 3.64 1.106 4.836.737 1.196 1.948 1.794 3.632 1.794 1.001 0 1.869-.117 2.606-.351a6.97 6.97 0 001.974-.975v3.783c-1.132.806-2.75 1.209-4.856 1.209z",
    fill: "url(#YandexPlus_svg__YandexPlus_svg__paint3_linear_20777_110404)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.991 20.145c-1.579-1.768-3.632-2.652-6.159-2.652-2.237 0-4.119.702-5.646 2.106-1.527 1.378-2.461 3.393-2.803 6.045h-2.685v-7.761H205V37.5h4.698v-8.19h2.646c.263 2.782 1.158 4.914 2.684 6.396 1.553 1.456 3.488 2.184 5.804 2.184 2.527 0 4.58-.871 6.159-2.613 1.606-1.768 2.409-4.303 2.409-7.605 0-3.276-.803-5.785-2.409-7.527zm-3.395 12.519c-.606 1.04-1.527 1.56-2.764 1.56-1.237 0-2.171-.52-2.803-1.56-.605-1.04-.908-2.691-.908-4.953 0-2.288.303-3.952.908-4.992.632-1.04 1.566-1.56 2.803-1.56 1.237 0 2.158.52 2.764 1.56.631 1.04.947 2.69.947 4.953 0 2.288-.316 3.952-.947 4.992z",
    fill: "url(#YandexPlus_svg__YandexPlus_svg__paint4_linear_20777_110404)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.454 37.5h4.768V10.38h-6.955c-6.985 0-10.66 3.54-10.66 8.79 0 4.17 2.005 6.63 5.619 9.15L0 37.5h5.163l6.955-10.26-2.4-1.59c-2.945-1.95-4.373-3.48-4.373-6.75 0-2.88 2.065-4.83 5.953-4.83h2.126V37.5h.03zm92.113.39c2.157 0 3.706-.39 4.86-1.2v-3.78c-1.185.81-2.612 1.32-4.586 1.32-3.371 0-4.738-2.58-4.738-6.63 0-4.26 1.701-6.45 4.768-6.45 1.822 0 3.584.63 4.525 1.2v-3.93c-.972-.54-2.733-.93-5.041-.93-6.014 0-9.111 4.26-9.111 10.23 0 6.54 3.037 10.17 9.323 10.17zm-29.368-1.71V32.4c-1.457.96-3.918 1.83-6.195 1.83-3.432 0-4.738-1.59-4.92-4.86h11.328v-2.46c0-6.84-3.037-9.39-7.745-9.39-5.74-.03-8.473 4.29-8.473 10.23 0 6.84 3.402 10.14 9.385 10.14 3.006 0 5.223-.78 6.62-1.71zm-43.035-18.3v7.77h-6.286v-7.77H22.17V37.5h4.708v-8.19h6.286v8.19h4.708V17.88h-4.708zM59.04 33.84h-2.096V17.88H43.247v1.68c0 4.8-.303 11.01-1.974 14.28h-1.457V42h4.342v-4.5h10.539v4.47h4.343v-8.13zm32.162 3.66h5.315l-7.532-10.56 6.62-9.06h-4.737l-6.62 9.06v-9.06H79.54V37.5h4.707v-9.63l6.955 9.63zM68.576 21.15c2.339 0 3.037 1.92 3.037 4.38v.39h-6.56c.122-3.12 1.276-4.77 3.523-4.77zM52.267 33.84h-6.65c1.305-2.97 1.67-8.31 1.67-11.7v-.57h4.98v12.27z",
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "YandexPlus_svg__YandexPlus_svg__paint0_linear_20777_110404",
    x1: 118.444,
    y1: 21.6,
    x2: 154.889,
    y2: 21.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#EB469F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8341EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "YandexPlus_svg__YandexPlus_svg__paint1_linear_20777_110404",
    x1: 164,
    y1: 22.309,
    x2: 246,
    y2: 22.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8341EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F68F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "YandexPlus_svg__YandexPlus_svg__paint2_linear_20777_110404",
    x1: 164,
    y1: 22.31,
    x2: 246,
    y2: 22.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8341EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F68F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "YandexPlus_svg__YandexPlus_svg__paint3_linear_20777_110404",
    x1: 164,
    y1: 22.309,
    x2: 246,
    y2: 22.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8341EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F68F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "YandexPlus_svg__YandexPlus_svg__paint4_linear_20777_110404",
    x1: 164,
    y1: 22.309,
    x2: 246,
    y2: 22.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8341EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F68F9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "YandexPlus_svg__YandexPlus_svg__clip0_20777_110404"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 6)",
    d: "M0 0h246v36H0z"
  }))));
};

exports.YandexPlus = YandexPlus;
var _default = YandexPlus;
exports.default = _default;